export default {
    //Takeoff
    TAKEOFF_DELAY: 1000,
    TAKEOFF_DURATION: 5000,

    //Leaving Earth
    TAKEOFF_COMPLETE_DELAY: 1000,

    //Separating the rocket stages
    ROCKET_STAGE_SEPARATION_DELAY: 500,
    ROCKET_STAGE_SEPARATION_DURATION: 1000,
    ROCKET_STAGE_DRIFT_DURATION: 30000
}

